import { useState, useEffect } from 'react';
import { _AgreementClassification, _BusinessType } from '../../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../../core/services/dataBean/useDataBean';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const BusinesTypeSelect = ({ idSelector, onChange, label }: Props) => {

    const business = useDataBean(_BusinessType)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(0);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [])


    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }



    const getLista = () => {

        business.instance.getBusinessTypeCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }

    return (
        <>
            <label>{label ?? "Tipo de Negocio:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBusinessType} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}